import {
	Box,
	ColumnLayout,
	Container,
	Header,
	SpaceBetween
} from '@cloudscape-design/components'
import TextContent from '@cloudscape-design/components/text-content'
import { FC } from 'react'

import {
	getApplicationFieldDisplayValue,
	groupApplicationFields
} from '../../../helper/applicationFieldGroups'
import type { ApplicationField } from '../../../helper/applicationFieldGroups'

interface ApplicationProps {
	Application: ApplicationField[]
}

const ValueWithLabel: FC<ApplicationField> = ({ label, value }) => (
	<div>
		<Box variant="awsui-key-label">{label}</Box>
		<TextContent>
			<p>{getApplicationFieldDisplayValue({ label, value })}</p>
		</TextContent>
	</div>
)

const RenderApplicationFields: FC<ApplicationProps> = ({ Application }) => (
	<Container header={<Header variant="h2">Request Details</Header>}>
		<SpaceBetween direction="vertical" size="l">
			{groupApplicationFields(Application).map((group) => (
				<section key={group.title} aria-label={group.title}>
					<SpaceBetween direction="vertical" size="s">
						
						<Header variant="h3">{group.title}</Header>
						
						<ColumnLayout columns={3} variant="text-grid">
							{group.fields.map((field, index) => (
								<ValueWithLabel {...field} key={`${field.label}-${index}`} />
							))}
						</ColumnLayout>
					</SpaceBetween>
				</section>
			))}
		</SpaceBetween>
	</Container>
)

export default RenderApplicationFields
